// How a campaign looks. "Season" wears colours that feel like the time of
// year (the closest of each design's own colourways) until the season kits
// arrive with their own art; "brand" wears the salon's brand colour.
import { layoutOf } from '../../social/data/postTypes'

// For each season: editorial, poster, quiet, and the layouts' theme
const SEASON = {
  autumn: ['terracotta', 'orange', 'butter', 'paper'],
  halloween: ['terracotta', 'orange', 'peach', 'lilac'],
  bonfire: ['navy', 'orange', 'sky', 'electric'],
  movember: ['espresso', 'acid', 'stone', 'paper'],
  'black-friday': ['blush', 'acid', 'stone', 'electric'],
  'christmas-vouchers': ['forest', 'red', 'sage', 'olive'],
  'party-season': ['burgundy', 'acid', 'butter', 'cherry'],
  nye: ['navy', 'acid', 'butter', 'electric'],
  'new-year': ['navy', 'cobalt', 'sky', 'paper'],
  valentines: ['burgundy', 'pink', 'rose', 'cherry'],
  'mothers-day': ['blush', 'pink', 'rose', 'rose'],
  'st-patricks': ['forest', 'pink', 'sage', 'sage'],
  spring: ['blush', 'mint', 'butter', 'lilac'],
  easter: ['blush', 'mint', 'butter', 'lilac'],
  prom: ['navy', 'mint', 'rose', 'lilac'],
  weddings: ['espresso', 'pink', 'stone', 'paper'],
  'fathers-day': ['navy', 'cobalt', 'sky', 'electric'],
  'summer-start': ['navy', 'orange', 'sky', 'electric'],
  summer: ['navy', 'orange', 'sky', 'electric'],
  'back-to-school': ['navy', 'red', 'sky', 'electric'],
}
const INDEX = { editorial: 0, poster: 1, quiet: 2, layouts: 3 }

export const hasSeasonLook = (momentId) => !!SEASON[momentId]

// The colourway a design wears in a campaign's look (undefined: the design's own)
export const colourwayFor = ({ look, momentId, brandColour }, family, type, layout) => {
  if (look === 'brand' && brandColour) return 'brand'
  const set = SEASON[momentId]
  if (look === 'season' && set) return set[INDEX[family]]
  // Each design's own: a layout's own theme, else the style's first colourway
  if (family === 'layouts') { const l = layoutOf(type, layout); return l ? l.theme : undefined }
  return undefined
}

// The look a campaign starts in: its season's colours when it has them
export const startingLook = (momentId, brandColour) => (SEASON[momentId] ? 'season' : brandColour ? 'brand' : 'own')

export const LOOK_NAMES = { season: 'Season colours', brand: 'Your brand colours', own: 'Each design’s own colours' }
